let theme = sessionStorage.getItem('theme')
export default {
  state: {
    infoTab:null,
    isFirstLaunch: true,
    theme: theme,
    pbrIndexModule: { currentModule: '', sj: { params: {}, tags: [] }, xm: { params: {}, tags: [] }, fx: { params: {}, tags: [] } }
  },
  mutations: {
    theme(state, value) {
      state.theme = value || 'white'
    },
    isFirstLaunch(state, value) {
      state.isFirstLaunch = value
    },
    pbrIndexModule(state, value) {
      let data = Object.assign({}, state.pbrIndexModule, value)
      state.pbrIndexModule = data
    },
    infoTab(state,value){
      state.infoTab = value
    }
  },
  actions: {
    isFirstLaunch ({commit, rootState},anotherName) {
      commit("isFirstLaunch", anotherName)
    },
  }
}
